import React, {useState} from 'react'
import useMutate from 'apollo-hooks/lib/useMutate'
import useQuery from 'apollo-hooks/lib/useApolloQuery'
import ClickOutside from 'react-click-outside'
import gql from 'graphql-tag'
import useMessage from 'App/hooks/useMessage'
import styles from './styles.css'
import UserAvatar from '../UserAvatar'
import useUserId from 'App/hooks/useUserId'
import ToggleRow from '../../shared/ToggleRow'

export default function UserAccount() {
  const mutate = useMutate()
  const userId = useUserId()

  const [open, setIsOpen] = useState(false)
  const showMessage = useMessage()

  const {user} = useQuery({
    query: gql`
      query getMe {
        user: me {
          _id
          fullName
          activeForAutoAssignChat
          inboxPreference {
            _id
            countryCodes
          }
        }
      }
    `
  })

  const {countries} = useQuery({
    query: gql`
      query {
        countries {
          code
          name
          emoji
        }
      }
    `
  })

  async function toggleActiveForAutoAssignChat() {
    await mutate({
      mutation: gql`
        mutation toggleActiveForAutoAssignChat {
          toggleActiveForAutoAssignChat
        }
      `,
      refetchQueries: ['getMe']
    })
    showMessage('Preferencias actualizadas')
  }

  async function toggleCountryPreference(value) {
    await mutate({
      mutation: gql`
        mutation toggleCountryPreference($userId: ID, $value: ID) {
          toggleCountryPreference(userId: $userId, value: $value)
        }
      `,
      variables: {userId, value},
      refetchQueries: ['getMe']
    })
    showMessage('Preferencias actualizadas')
  }

  const {fullName: userName, activeForAutoAssignChat: active, inboxPreference} = user

  return (
    <ClickOutside onClickOutside={() => setIsOpen(false)}>
      <div className={styles.container}>
        <div role="button" onClick={() => setIsOpen(op => !op)}>
          <UserAvatar userName={userName} active={active} />
        </div>
        {open ? (
          <div className={styles.options}>
            <div className={styles.row}>
              <h4>Mi cuenta</h4>
            </div>
            <ToggleRow
              label="Recibiendo chats"
              active={active}
              onToggle={toggleActiveForAutoAssignChat}
            />
            <div className={styles.row}>
              <h4>Preferencias</h4>
            </div>
            {countries.map(({code, name, emoji}) => (
              <ToggleRow
                key={code}
                label={`${name} ${emoji}`}
                active={inboxPreference.countryCodes.includes(code)}
                onToggle={() => toggleCountryPreference(code)}
                rowStyle="row"
              />
            ))}
          </div>
        ) : null}
      </div>
    </ClickOutside>
  )
}
